import { create } from "zustand";
import { devtools } from "zustand/middleware";
import jwtDecode from "jwt-decode";
import {getCouriers,getAllCouriers,filterCouriers,exportCouriers,getCourierTasks,
exportTasks,getConsignmentStatus,assignSupplier,getConsignmentTaskType,configureCourierHubs,getTeamLeaders,
postTeamLeaders,updateTeamLeaders,deleteTeamLeaders,getUnAssignedCouriers,getCouriersByTeamLeader,exportTeamLeader,
getPerformance,getPerformancebyCourier,exportPerformance,getPerformancebyGroups,
registerCourierInTGA,getTeamLeadersV2,getPerformanceV2,
getCourierPerformance,getCourierPerformancebyGroupsV2,getCourierPerformanceV2,
exportCourierPerformanceV2,exportPerformanceV2,logoutUser,getPerformancebyGroupsV2,filterCouriersV2,getCouriersV2,recordAnalyticsHit,
exportCourierPerformanceDetails,exportNotValidatedPerformance,getValidationLatest,syncTeamLeader,getValidationStatistics,uploadTLValidationProof,submitTeamLeaderValidation,getTLValidationRemark,saveTeamLeaderNote} from "../../services/CourierManagement/courier_services"
const initialValues = {
    courierStatus: [],
    couriertaskType: [],
    courierData: [],
    selectedCourierCode: "",
    tlValidationRemarkList: [],
};
let courierStore = (set) => ({
    ...initialValues,
    getCouriers: async (params) => {
        const response = await getCouriers(params);
        return response;
      },
      getCouriersV2: async (params) => {
        const response = await getCouriersV2(params);
        return response;
      },
      getAllCouriers: async (params) => {
        const response = await getAllCouriers(params);
        return response;
      },
      filterCouriers: async (params) => {
        const response = await filterCouriers(params);
        set({ courierData: response });
        return response;
      },
        filterCouriersV2: async (params) => {
        const response = await filterCouriersV2(params);
        set({ courierData: response });
        return response;
      },
      exportCouriers: async (params) => {
        const response = await exportCouriers(params);
        return response;
      },
      getCourierTasks: async (params) => {
        const response = await getCourierTasks(params);
        return response;
      },
      configureCourierHubs: async (params,data) => {
        const response = await configureCourierHubs(params,data);
        return response;
      },
      exportTasks: async (params) => {
        const response = await exportTasks(params);
        return response;
      },
      assignSupplier: async (params,data) => {
        const response = await assignSupplier(params,data);
        return response;
      },
      getConsignmentStatus: async () => {
        const response = await getConsignmentStatus();
        set({ courierStatus: response?.data?.data });
        return response;
      },
      getConsignmentTaskType: async () => {
        const response = await getConsignmentTaskType();
        set({ couriertaskType: response?.data?.data });
        return response;
      },
      setselectedCourierCode: (data) => set({ selectedCourierCode: data }),
      getTeamLeaders: async (params) => {
        const response = await getTeamLeaders(params);
        return response;
      },
      getTeamLeadersV2: async (params) => {
        const response = await getTeamLeadersV2(params);
        return response;
      },
      postTeamLeaders: async (params) => {
        const response = await postTeamLeaders(params);
        return response;
      },
      updateTeamLeaders: async (params,data) => {
        const response = await updateTeamLeaders(params,data);
        return response;
      },
      deleteTeamLeaders: async (params) => {
        const response = await deleteTeamLeaders(params);
        return response;
      },
      getCouriersByTeamLeader: async (params) => {
        const response = await getCouriersByTeamLeader(params);
        return response;
      },
      exportTeamLeader: async (params) => {
        const response = await exportTeamLeader(params);
        return response;
      },
      getUnAssignedCouriers: async (params) => {
        const response = await getUnAssignedCouriers(params);
        return response;
      },
      getPerformance: async (params) => {
        const response = await getPerformance(params);
        return response;
      },
        getPerformanceV2: async (params) => {
        const response = await getPerformanceV2(params);
        return response;
      },
      getPerformancebyCourier: async (params) => {
        const response = await getPerformancebyCourier(params);
        return response;
      },
      exportPerformance: async (params) => {
        const response = await exportPerformance(params);
        return response;
      },
      exportPerformanceV2: async (params) => {
        const response = await exportPerformanceV2(params);
        return response;
      },
      getPerformancebyGroups: async (params) => {
        const response = await getPerformancebyGroups(params);
        return response;
      },
       getPerformancebyGroupsV2: async (params) => {
        const response = await getPerformancebyGroupsV2(params);
        return response;
      },
      registerCourierInTGA: async (params) => {
        const response = await registerCourierInTGA(params);
        return response;
      },
       logoutUser: async (params) => {
        const response = await logoutUser(params);
        return response;
      },
       getCourierPerformance: async (params) => {
        const response = await getCourierPerformance(params);
        return response;
      },
       getCourierPerformancebyGroupsV2: async (params) => {
        const response = await getCourierPerformancebyGroupsV2(params);
        return response;
      },
       getCourierPerformanceV2: async (params) => {
        const response = await getCourierPerformanceV2(params);
        return response;
      },
       exportCourierPerformanceV2: async (params) => {
        const response = await exportCourierPerformanceV2(params);
        return response;
      },
       exportCourierPerformanceDetails: async (params) => {
        const response = await exportCourierPerformanceDetails(params);
        return response;
      },
       exportNotValidatedPerformance: async (params) => {
        const response = await exportNotValidatedPerformance(params);
        return response;
      },
       getValidationLatest: async (trackingId) => {
        const response = await getValidationLatest(trackingId);
        return response;
      },
       syncTeamLeader: async (employeeCode) => {
        const response = await syncTeamLeader(employeeCode);
        return response;
      },
       getValidationStatistics: async (params) => {
        const response = await getValidationStatistics(params);
        return response;
      },
       uploadTLValidationProof: async (trackingId, formData) => {
        const response = await uploadTLValidationProof(trackingId, formData);
        return response;
      },
       submitTeamLeaderValidation: async (data) => {
        const response = await submitTeamLeaderValidation(data);
        return response;
      },
       saveTeamLeaderNote: async (data) => {
        const response = await saveTeamLeaderNote(data);
        return response;
      },
       getTLValidationRemark: async () => {
        const response = await getTLValidationRemark();
        set({ tlValidationRemarkList: response?.data?.data });
        return response;
      },
       // Record a feature-usage hit. Components only pass the feature key;
       // employeeCode is derived here from the logged-in user's token.
       trackFeature: async (feature) => {
        try {
          const token = sessionStorage.getItem("user_access_token");
          const employeeCode = token
            ? jwtDecode(token)?.attributes?.employeeCode
            : "";
          if (!feature || !employeeCode) return;
          return await recordAnalyticsHit({ feature, employeeCode });
        } catch (error) {
          // analytics tracking is best-effort; ignore failures
          return error;
        }
      },
});

courierStore = devtools(courierStore);

export const usecourierStore = create(courierStore);